import { useResponsive } from "../../hooks/useResponsive";

const ResponsiveRenderer = ({ desktop, tablet = null, mobile = null, fallback = null }) => {
	const { isMobile, isTablet, isDesktop } = useResponsive();

	if (isMobile) return mobile || tablet || desktop || fallback;
	if (isTablet) return tablet || mobile || desktop || fallback;
	if (isDesktop) return desktop || tablet || mobile || fallback;

	return fallback;
};

export default ResponsiveRenderer;
